var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreeDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 18,
    viewBox: "0 0 6 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.00081 4C2.42618 4 1.87508 3.78929 1.46875 3.41421C1.06242 3.03914 0.834146 2.53043 0.834146 2C0.834146 1.46957 1.06242 0.960859 1.46875 0.585786C1.87508 0.210714 2.42618 0 3.00081 0C3.57545 0 4.12655 0.210714 4.53288 0.585786C4.93921 0.960859 5.16748 1.46957 5.16748 2C5.16748 2.53043 4.93921 3.03914 4.53288 3.41421C4.12655 3.78929 3.57545 4 3.00081 4ZM3.00081 11C2.42618 11 1.87508 10.7893 1.46875 10.4142C1.06242 10.0391 0.834146 9.53043 0.834146 9C0.834146 8.46957 1.06242 7.96086 1.46875 7.58579C1.87508 7.21071 2.42618 7 3.00081 7C3.57545 7 4.12655 7.21071 4.53288 7.58579C4.93921 7.96086 5.16748 8.46957 5.16748 9C5.16748 9.53043 4.93921 10.0391 4.53288 10.4142C4.12655 10.7893 3.57545 11 3.00081 11ZM3.00081 18C2.42618 18 1.87508 17.7893 1.46875 17.4142C1.06242 17.0391 0.834146 16.5304 0.834146 16C0.834146 15.4696 1.06242 14.9609 1.46875 14.5858C1.87508 14.2107 2.42618 14 3.00081 14C3.57545 14 4.12655 14.2107 4.53288 14.5858C4.93921 14.9609 5.16748 15.4696 5.16748 16C5.16748 16.5304 4.93921 17.0391 4.53288 17.4142C4.12655 17.7893 3.57545 18 3.00081 18Z",
    fill: "#C6CCFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDots);
export default __webpack_public_path__ + "static/media/threeDots.31ce1d43c2e08dd7d0de898814774a80.svg";
export { ForwardRef as ReactComponent };